import jwt_decode from "jwt-decode";
import { USER_TYPES } from "./permissions";

const TOKEN_KEY = "jhms_token";

export function getStoredToken() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token || token === "null" || token === "undefined") {
    return null;
  }
  return token;
}

export function isTokenValid(token) {
  if (!token) return false;
  try {
    const decoded = jwt_decode(token);
    if (decoded.exp && decoded.exp * 1000 <= Date.now()) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function getValidToken() {
  const token = getStoredToken();
  return isTokenValid(token) ? token : null;
}

export function clearStoredAuth() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getUserTypeFromToken(token) {
  try {
    const decoded = jwt_decode(token);
    return decoded.rese?.usertype ?? decoded.usertype ?? null;
  } catch {
    return null;
  }
}

export function getDefaultRouteForToken(token) {
  const userType = getUserTypeFromToken(token);
  if (userType === USER_TYPES.KITCHEN) return "/kitchen/orders";
  if (userType === USER_TYPES.WAITER) return "/waiter";
  return "/";
}

export function isWaiterRouteAllowed(path) {
  if (!path) return false;
  return (
    path === "/waiter" ||
    path.startsWith("/waiter/") ||
    path.startsWith("/order/table") ||
    path === "/login"
  );
}

export function isKitchenRoute(path) {
  if (!path) return false;
  return path === "/kitchen/orders" || path.startsWith("/kitchen/");
}

export function getKitchenLoginPath() {
  return "/kitchen/login";
}
